import React, { useState } from 'react';
import { formatPrice, parsePrice } from '../utils/format';

/**
 * Champ de saisie de prix avec formatage automatique
 *
 * - Affichage (non focalisé) : 10.000,00 (point milliers, virgule décimale)
 * - Saisie (focalisé)        : valeur brute modifiable, accepte virgule ou point décimal
 * - Sur perte de focus       : normalise et reformate
 *
 * Compatible avec les handlers du type : onChange={v => setForm(f => ({ ...f, prix: v }))}
 * La valeur passée à onChange est une string numérique normalisée ("45000.5")
 */
export function PriceInput({
  value,
  onChange,
  className = '',
  style,
  placeholder = '0,00',
  disabled = false,
  'data-testid': testId,
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const [raw, setRaw] = useState('');

  const handleFocus = (e) => {
    setFocused(true);
    // Afficher valeur brute pour l'édition : convertir "45000.5" → "45000,5"
    const str = String(value ?? '');
    const edited = str === '' ? '' : str.replace('.', ',');  // 1er point = décimale stockée
    setRaw(edited);
    setTimeout(() => e.target.select(), 0);
  };

  const handleChange = (e) => {
    setRaw(e.target.value);
    // Passer la valeur brute au parent pendant la saisie
    onChange(e.target.value);
  };

  const handleBlur = () => {
    setFocused(false);
    const parsed = parsePrice(raw);
    if (parsed != null) {
      // Normaliser : stocker comme string numérique avec point décimal
      onChange(String(parsed));
    } else if (raw.trim() === '') {
      onChange('');
    }
    // Si invalide, on ne change pas la valeur parente
  };

  // Valeur affichée
  let displayValue;
  if (focused) {
    displayValue = raw;
  } else {
    const num = parsePrice(String(value ?? ''));
    displayValue = num != null ? formatPrice(num) : (value ? String(value) : '');
  }

  return (
    <input
      {...props}
      type="text"
      inputMode="decimal"
      data-testid={testId}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      className={className}
      style={style}
      disabled={disabled}
    />
  );
}
